import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';
  const isDarkHeaderPage = location.pathname.startsWith('/blog');

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrolled]);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const scrollToSection = (sectionId) => {
    setMobileMenuOpen(false);
    if (isHomePage) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${isDarkHeaderPage ? 'dark-header-page' : ''}`}>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img src="/images/logo.svg" alt="Jajoga - Salon & Franchise Intelligence" className="logo-image" />
        </Link>
        <ul className={`nav-menu ${mobileMenuOpen ? 'mobile-open' : ''}`} id="nav-menu">
          <li><button onClick={() => scrollToSection('hero')} aria-label="Go to Home section">Home</button></li>
          <li><button onClick={() => scrollToSection('what-we-deliver')} aria-label="Go to Services section">Services</button></li>
          <li><Link to="/blog" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Blog</Link></li>
          <li><a href="https://support.jajoga.com" target="_blank" rel="noopener noreferrer">Support</a></li>
          <li><button onClick={() => scrollToSection('contact')} aria-label="Go to Contact section">Contact</button></li>
        </ul>
        <button
          className="mobile-menu-toggle"
          aria-expanded={mobileMenuOpen}
          aria-controls="nav-menu"
          aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
          onClick={toggleMobileMenu}
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button>
        <button className="nav-cta" onClick={() => scrollToSection('contact')} aria-label="Get Started - Go to Contact section">
          Get Started
        </button>
      </div>
    </nav>
  );
};

export default Navigation;
